"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setStatus = setStatus;
const dist_1 = require("../../core/dist");
/**
 * The single status verb. Flips a plain doc's lifecycle status (draft/active/done/…)
 * with NO version/`updated` bump — a status change is a lifecycle event, not a spec
 * revision, so it must not cascade false staleness to children (see
 * loom/refs/staleness-reference.md).
 *
 * Guarded transitions a dedicated tool owns (plan→implementing/done, req→locked) are
 * refused with a pointer to that tool; a status invalid for the type is rejected. The
 * decision is delegated to the pure `decideSetStatus` in core.
 */
async function setStatus(input, deps) {
    const loomRoot = deps.getActiveLoomRoot();
    const docPath = await deps.findDocumentById(loomRoot, input.docUlid);
    if (!docPath) {
        throw new Error(`Document with ID '${input.docUlid}' not found.`);
    }
    const doc = await deps.loadDoc(docPath);
    const decision = (0, dist_1.decideSetStatus)(doc.type, input.status);
    if (decision.kind === 'delegate') {
        throw new Error(`Refusing to set a ${doc.type} to '${input.status}' via set-status — use ${decision.tool} (${decision.reason}).`);
    }
    if (decision.kind === 'reject') {
        throw new Error(decision.reason);
    }
    // Idempotent no-op if already at the target status.
    if (doc.status === input.status) {
        return { id: doc.id, status: input.status, filePath: docPath };
    }
    const updated = { ...doc, status: input.status };
    await deps.saveDoc(updated, docPath);
    return { id: doc.id, status: input.status, filePath: docPath };
}
